import config from 'config';
import { NativeSupportHandlerV2 } from '@bharatpe/native-support-handler';
import { toast } from 'react-toastify';
import { getAppVersion, handleValidation, isIOS, isUpdatedApp, nativeHandler, CleverTapEvent } from '.';
import globalConstant from 'constants/globalConstant';
import msgConstants from 'constants/msgConstant';

const projectName = config.projectName;
window.androidObj = function AndroidClass() {};
//undefined callbacks
window.callBackDeeplink = () => {
	console.log('deeplink callback');
};

window.callbackOnSubscribeBackButton = () => {
	console.log('back subscription callback');
};

window.callbackPermissionFailure = () => {
	console.log('permission failure callback');
};

window.callBackPSPDialogInfo = () => {
	console.log('psp dialog callback');
};

window.callbackSubscribeBackPressed = () => {
	console.log('back pressed subscription callback');
};

const androidPermissions = {
	location: {
		permission: 'ACCESS_FINE_LOCATION',
	},
	contacts: {
		permission: 'READ_CONTACTS',
	},
	sms: {
		permission: 'READ_SMS',
	},
	phone: {
		permission: 'READ_PHONE_STATE',
	},
	call_history: {
		permission: 'READ_CALL_LOG',
	},
	calender: {
		permission: 'READ_CALENDAR',
	},
	storage: {
		permission: 'READ_EXTERNAL_STORAGE',
	},
	camera: {
		permission: 'CAMERA',
	},
};

const nativeFunctions = {
	sendRawNativeData: function (nativeData) {
		console.log('nativeHookCalled:', nativeData);
		if (window.androidObj.nativeSupport) window.androidObj.nativeSupport(JSON.stringify(nativeData));
	},

	closeWebView: function () {
		NativeSupportHandlerV2.closeWebView()
			.then(() => {
				// do something on webview closed
			})
			.catch(() => {
				console.error('Error while closing Web view');
			});
	},

	openPSPModal: function (upi_string, callback) {
		NativeSupportHandlerV2.openPSPModal(upi_string, projectName)
			.then((res) => {
				callback && callback();
			})
			.catch((errStatus) => {
				if (errStatus === globalConstant.PSP_MODAL_STATUS.NO_PSP_INSTALLED) {
					toast.error(msgConstants.NO_PSP_APP_FOUND);
				} else if (errStatus !== globalConstant.PSP_MODAL_STATUS.USER_CLOSED) {
					toast.error(msgConstants.SOMETHING_WRONG);
				}
			});
	},

	openURL: function (url) {
		NativeSupportHandlerV2.openUrl(url);
	},

	openDeepLinkWithoutCallback: function (deepLink) {
		NativeSupportHandlerV2.openDeeplink(deepLink);
	},

	openDeepLinkWithCallback: function (deepLink, callback) {
		this.showLoader();
		let finalDeepLink = deepLink;
		window.callbackOpenOrderCard = () => {
			callback && callback('OrderCard');
		};
		window.callbackIncreaseSpendLimit = () => {
			callback && callback('IncreaseLimit');
		};
		window.callbackCardActivityClosed = () => {
			callback && callback('ActivityClosed');
		};
		if (deepLink?.toString().includes('dynamic')) {
			finalDeepLink = `${deepLink}&resultCode=true`;
		}
		NativeSupportHandlerV2.openSimBindingDeepLink(finalDeepLink)
			.then(() => {
				callback && callback();
			})
			.catch(() => {
				toast.error(msgConstants.AUTO_REFRESH_FAILED);
			});
	},

	sendCleverTapEvent: function (eventName, eventParams) {
		NativeSupportHandlerV2.cleverTrackEvent(eventName, eventParams);
	},

	getAppInfo: function () {
		return new Promise((resolve, reject) => {
			window.callBackappInfo = (success, data) => {
				const parsedData = JSON.parse(data);
				localStorage.setItem('appInfo', data);
				localStorage.setItem('visa', parsedData['token']);
				localStorage.setItem('latitude', parsedData['latitude'] || '');
				localStorage.setItem('longitude', parsedData['longitude'] || '');
				if (success) {
					resolve(parsedData);
					console.log(data);
				} else {
					reject(data);
				}
			};

			const nativeData = {};
			nativeData['key'] = 6;
			this.sendRawNativeData(nativeData);
		});
	},

	openScanner: function () {
		return new Promise((resolve, reject) => {
			window.callBackScanner = window.callbackScanner = (success, error, data) => {
				console.log({
					success,
					error,
					data,
				});
				if (success) {
					if (data?.includes('https://postpe.club')) {
						if (data === 'https://postpe.club/tnc') {
							return this.activateCard().catch((error) => reject(error));
						}
						reject();
						nativeHandler.closeWebView();
						this.openURL(data);
					} else {
						const isValidIntent = handleValidation.validate('upi', data, 1);
						if (isValidIntent) {
							resolve(data);
						} else {
							reject('Invalid data');
							toast.error('Invalid QR');
						}
					}
				} else {
					reject('Invalid data');
				}
			};

			window.onPosScannerSuccess = (data) => {
				console.log({
					data,
				});
				if (data?.includes('https://postpe.club')) {
					if (data === 'https://postpe.club/tnc') {
						return this.activateCard().catch((error) => reject(error));
					}
					reject();
					nativeHandler.closeWebView();
					this.openURL(data);
				} else {
					const isValidIntent = handleValidation.validate('upi', data, 1);
					if (isValidIntent) {
						resolve(data);
					} else {
						reject('Invalid data');
						toast.error('Invalid QR');
					}
				}
			};

			window.onPosScannerError = (error) => {
				console.log({ error });
				reject('Invalid data');
			};

			const nativeData = {};
			nativeData['key'] = isIOS || !isUpdatedApp(110) ? 14 : 49;
			nativeData['scanner'] = 'postpe';
			this.sendRawNativeData(nativeData);
		});
	},

	// logoutZeta: function (cb) {
	// 	return new Promise((resolve, reject) => {
	// 		const nativeData = {};
	// 		nativeData['key'] = 80;
	// 		window.callBackCardLogout = () => {
	// 				resolve(cb());
	// 		}
	// 		this.sendRawNativeData(nativeData);
	// 	});
	// },

	showLoader: function (props) {
		let nativeData = { ...props };
		if (!props) {
			nativeData = globalConstant.DEFAULT_LOADER;
		}
		document.body.classList.add('abcde');
		console.log('======== SHOW LOADER ========');
		nativeData['key'] = 45;
		this.sendRawNativeData(nativeData);
	},

	removeLoader: function () {
		const nativeData = {};
		nativeData['key'] = 46;
		console.log('======== REMOVE LOADER ========');
		setTimeout(() => {
			this.sendRawNativeData(nativeData);
		}, 1000);
	},

	openCamera: function (frontCamera = false) {
		return new Promise((resolve, reject) => {
			const nativeData = {};
			window.callBackCamera = (success, error, data) => {
				if (success) {
					const finalImage = 'data:image/jpeg;base64,' + data;
					resolve(finalImage);
				}
				if (error) {
					reject(data);
				}
			};
			window.callBackInternalCamera = (success, img) => {
				if (success) {
					const finalImage = 'data:image/jpeg;base64,' + img;
					resolve(finalImage);
				}
			};
			nativeData['key'] = 55;
			nativeData['cameraType'] = 1;
			this.sendRawNativeData(nativeData);
		});
	},

	openAadharKycSdk: function () {
		return new Promise((resolve, reject) => {
			const deeplink = 'bharatpe://ekyc?resultCode=true';
			this.openDeepLinkWithCallback(deeplink, () => resolve());
		});
	},

	mandatePermissions: function (getContacts) {
		return new Promise((resolve, reject) => {
			window.onSubscribePermissionCallback = (isGiven) => {
				if (isGiven) {
					console.log('contact permission there');
					getContacts && this.getContacts(true);
					resolve();
				} else {
					reject();
				}
			};
			const nativeData = {};
			nativeData['key'] = 68;
			nativeData['permissions'] = ['android.permission.READ_CONTACTS'];
			nativeData['isCancelable'] = true;
			this.sendRawNativeData(nativeData);
		});
	},

	handleActivate: function () {
		new Promise((resolve) => {
			window.callBackInitZetaSDK = (success) => {
				const nativeData = {
					key: 59,
				};
				if (success) {
					nativeData['key'] = 60;
				}
				this.sendRawNativeData(nativeData);
			};

			window.callBackSetPin = (isPinSet) => {
				if (isPinSet) {
					resolve();
					return;
				}
				if (!isIOS) {
					const nativeData = {
						key: 59,
					};
					this.sendRawNativeData(nativeData);
				}
			};

			window.callbackZetaCardsSetupSDK = (success) => {
				if (!success) {
					const nativeData = {
						key: 59,
					};
					this.sendRawNativeData(nativeData);
				}
			};

			const nativeData = {};
			nativeData['key'] = 60;
			this.sendRawNativeData(nativeData);
		});
	},

	activateCard: function () {
		return getAppVersion() >= (!isIOS ? 118 : 104)
			? new Promise((resolve, reject) => {
					this.openBiometricOnlyAtUserEnd()
						.then(() => {
							this.handleActivate();
							resolve();
						})
						.catch((errorMessage) => {
							reject(errorMessage);
						});
			  })
			: this.handleActivate();
	},

	sendWidgetData: function (usedBalance, availableBalance) {
		return new Promise((resolve, reject) => {
			const nativeData = {};
			nativeData['key'] = 82;
			nativeData['usedBalance'] = usedBalance;
			nativeData['availableBalance'] = availableBalance;
			this.sendRawNativeData(nativeData);
		});
	},

	otpAutoRead: function (context) {
		return new Promise((resolve, reject) => {
			window.callbackAppsignForInitOtpAutoread = (appSign) => {
				console.log('appSign', appSign);
				context === 'appSign' && resolve(appSign);
			};

			window.callbackOtpSuccess = (otp) => {
				console.log(otp);
				context === 'otp' && resolve(otp);
			};

			window.callbackOtpError = (error) => {
				console.log('error', error);
				reject(error);
			};

			window.callbackOtpAutoreadTimeout = () => {
				console.log('otp timeout');
				reject('Otp Timeout');
			};
			const nativeData = {};
			nativeData['key'] = 33;
			nativeData['lapseTime'] = 59000;
			this.sendRawNativeData(nativeData);
		});
	},

	openContactList: function () {
		return new Promise((resolve, reject) => {
			window.callbackSelectedContactInfo = (success, data) => {
				const contactData = data && JSON.parse(data);
				if (success && contactData && contactData.phoneNumbers && contactData.phoneNumbers.length > 0) {
					resolve({
						name: contactData.givenName,
						mobile: contactData.phoneNumbers[0].number,
					});
				} else {
					reject('Error in getting contact');
				}
			};
			window.callBackSingleContact = (success, error, mobile, name) => {
				if (success) {
					resolve({
						name,
						mobile,
					});
				}
				if (error) {
					reject('Error in getting contact');
				}
			};
			const nativeData = {};
			nativeData['key'] = isIOS ? '39' : '25';
			this.sendRawNativeData(nativeData);
		});
	},

	getContacts: function (forSyncContext, showLoader, route) {
		return new Promise((resolve, reject) => {
			// permission allow callback
			window.callBackContactInfo = (success, error, data) => {
				const contactData = data ? JSON.parse(data) : [];
				if (success) {
					if (contactData.length > 0) {
						if (forSyncContext) {
							console.table(contactData);
						}
						resolve(contactData);
					} else {
						reject(data);
					}
				} else {
					reject(data);
				}
			};

			// permission deny callback
			window.callbackPermissionFailure = () => {
				reject();
			};

			const nativeData = {};
			nativeData['key'] = 16;
			this.sendRawNativeData(nativeData);
		});
	},

	share: function (text, packageName) {
		return new Promise((resolve, reject) => {
			window.callbackOtherAppShareSuccess = () => {
				resolve();
			};

			window.callbackOtherAppShareFailed = (error) => {
				console.log(error);
				reject();
			};
			const nativeData = {};
			nativeData['key'] = packageName || isIOS ? 42 : 44;
			nativeData['url'] = '';
			nativeData['text'] = text;
			if (packageName) {
				nativeData['packageName'] = packageName;
			}
			this.sendRawNativeData(nativeData);
		});
	},

	takeScreenshotAndShare: function (props) {
		return new Promise((resolve, reject) => {
			window.callBackShareScreenShot = () => {
				resolve();
			};

			const nativeData = {
				key: 18,
				message: '',
				screenName: '',
				shareOn: '',
			};

			this.sendRawNativeData(nativeData);
		});
	},

	permissionsActions: function (action, permissions) {
		return new Promise((resolve, reject) => {
			window.onCheckPermissionsStatus = (result) => {
				const finalResult = result && JSON.parse(result);
				if (finalResult.hasOwnProperty('READ_SMS') && finalResult['READ_SMS']) {
					this.initSmsSync();
					this.subscribeSmsSync();
				}
				resolve(finalResult);
			};
			const nativeData = {};
			const finalPermissions = [];
			permissions.map((item, index) => {
				finalPermissions.push(androidPermissions[item]['permission']);
			});
			nativeData['permissions'] = finalPermissions;
			nativeData['key'] = action === 'status' ? 53 : 52;
			this.sendRawNativeData(nativeData);
		});
	},

	subscribeSmsSync: function () {
		return new Promise((resolve, reject) => {
			window.callbackonSubscribeSmsSync = (isDataSynced, message) => {
				// resolve(permissionsConstant)
			};
			const nativeData = {};
			nativeData['key'] = 51;
			this.sendRawNativeData(nativeData);
		});
	},

	initSmsSync: function () {
		return new Promise((resolve, reject) => {
			const nativeData = {};
			nativeData['key'] = 50;
			this.sendRawNativeData(nativeData);
		});
	},

	requestLocationPermission: function () {
		return new Promise((resolve, reject) => {
			window.callBackLocationAccess = (boolean, data) => {
				if (data?.includes(',')) {
					localStorage.setItem('latitude', data?.split(',')[0]);
					localStorage.setItem('longitude', data?.split(',')[1]);
					resolve(data?.split(',')[0], data?.split(',')[1]);
				} else {
					reject();
				}
			};
			const nativeData = {};
			nativeData['key'] = 12;
			this.sendRawNativeData(nativeData);
		});
	},

	getReferralLink: function () {
		return new Promise((resolve, reject) => {
			window.callbackAppsflyerReferralLink = (data) => {
				if (data) {
					resolve(data);
				} else {
					reject();
				}
			};
			const nativeData = {};
			nativeData['key'] = 38;
			nativeData['channel'] = 'User_invite';
			nativeData['message'] = '';
			nativeData['link_only'] = true;
			this.sendRawNativeData(nativeData);
		});
	},

	getInstalledApps: function () {
		return new Promise((resolve, reject) => {
			window.onPspFetched = (data) => {
				if (data) {
					resolve(JSON.parse(data));
				} else {
					reject();
				}
			};
			window.onPspFetchedFailed = (data) => {
				reject();
			};

			const nativeData = {};
			nativeData['key'] = 56;
			nativeData['data'] = ['com.whatsapp', 'com.facebook.katana', 'com.instagram.android'];
			this.sendRawNativeData(nativeData);
		});
	},

	playStoreRating: function () {
		return new Promise((resolve, reject) => {
			window.onInAppReviewSuccess = (data) => {
				if (data) {
					resolve(data);
				} else {
					reject();
				}
			};
			const nativeData = {};
			nativeData['key'] = 54;
			this.sendRawNativeData(nativeData);
		});
	},

	subscribeNotification: function (callback) {
		window.callbackNotificationReceived = (data) => {
			console.log({ notificationData: data });
			callback && callback(data);
		};
		const nativeData = {};
		nativeData['key'] = 71;
		nativeData['isSubscribed'] = true;
		this.sendRawNativeData(nativeData);
	},

	shareBase64: function (img) {
		return new Promise((resolve, reject) => {
			window.callBackShare = (data) => {
				console.log({ base64ShareData: data });
				resolve();
			};
			const nativeData = {
				key: 15,
				byteArray: img,
				message: 'Transaction Receipt',
			};
			this.sendRawNativeData(nativeData);
		});
	},

	openBiometric: function () {
		return new Promise((resolve, reject) => {
			window.callbackAuthenticateApp = (success, data) => {
				console.log({ success, data });
				success ? resolve(data) : reject(data);
			};
			window.callbackOpenAppSecuritySettings = () => {
				reject('openSettings');
			};
			const nativeData = {};
			nativeData['key'] = 20;
			nativeData['title'] = 'Authorize bharatpe';
			nativeData['description'] = 'Unlock your screen with PIN, Pattern, Password, Face or Fingerprint';
			this.sendRawNativeData(nativeData);
		});
	},

	openBiometricOnlyAtUserEnd: function () {
		return new Promise((resolve, reject) => {
			window.callbackIsScreenLockEnabled = (success) => {
				if (!success) {
					const nativeDataForCardLogout = {};
					nativeDataForCardLogout['key'] = 80;
					this.sendRawNativeData(nativeDataForCardLogout);
					reject('openSettings');
				} else {
					resolve();
				}
			};
			const nativeData = {};
			nativeData['key'] = 26;
			this.sendRawNativeData(nativeData);
		});
	},

	logout: function (source = 'logout_default') {
		CleverTapEvent.send(source);
		return new Promise((resolve, reject) => {
			const nativeData = {};
			nativeData['key'] = 63;
			this.sendRawNativeData(nativeData);
		});
	},

	openSettings: function () {
		return new Promise((resolve, reject) => {
			window.callbackOpenAppSecuritySettings = (success, data) => {
				if (success) {
					resolve(data);
				} else {
					reject();
				}
			};
			const nativeData = {};
			nativeData['key'] = 67;
			this.sendRawNativeData(nativeData);
		});
	},

	refreshHome: function () {
		return new Promise((resolve, reject) => {
			const nativeData = {};
			nativeData['key'] = 35;
			this.sendRawNativeData(nativeData);
		});
	},

	downloadAndShare: function (url) {
		return new Promise((resolve, reject) => {
			window.callbackSharePdf = (data) => {
				console.log(data);
			};
			const nativeData = {};
			nativeData['key'] = 29;
			nativeData['url'] = url;
			nativeData['shareOn'] = 'other';
			nativeData['type'] = 'mihit';
			nativeData['fileName'] = 'mihit';
			this.sendRawNativeData(nativeData);
		});
	},

	getSingleContact: function () {
		return new Promise((resolve, reject) => {
			window.callbackSelectedContactInfo = (success, data) => {
				console.log({
					success,
					data,
				});
				const parsedData = data && JSON.parse(data);
				if (success && parsedData) {
					resolve(parsedData);
				}
				reject();
			};

			const nativeData = {};
			nativeData['key'] = 25;
			nativeData['viewType'] = 'postpe';
			nativeData['headerTitle'] = 'choose contact number';
			nativeData['description'] = 'you need to provide contact permission';
			this.sendRawNativeData(nativeData);
		});
	},
	getSingleContactIOS: function () {
		return new Promise((resolve, reject) => {
			window.callBackSingleContact = (success, error, mobile, name) => {
				console.log({
					success,
					error,
					mobile,
					name,
				});
				mobile = mobile.replace(/\D/g, '').slice(-10);
				resolve({ phoneNumber: mobile, name: name });
			};

			const nativeData = {};
			nativeData.key = 39;
			nativeData.viewType = 'postpe';
			nativeData.headerTitle = 'choose contact number';
			this.sendRawNativeData(nativeData);
		});
	},
	openMerchantDeeplink: function (url) {
		return new Promise((res, rej) => {
			if (localStorage.getItem('third-party')) localStorage.removeItem('third-party');
			window.callbackThirdPartyWebViewInitiate = (res) => {
				console.log('Deeplink', res);
			};
			const payload = { key: 141, deeplink: url };
			res();
			this.sendRawNativeData(payload);
		});
	},

	getMultipleContacts: function () {
		return new Promise((resolve, reject) => {
			window.onMultipleContactSelectionSuccess = (data) => {
				const parsedData = JSON.parse(data);
				if (parsedData) {
					resolve(parsedData);
				}
				reject();
			};

			window.onMultipleContactSelectionError = () => {
				reject();
			};

			const nativeData = {};
			nativeData['key'] = 76;
			nativeData['sendMoneyBtn'] = 'Refer Now';
			nativeData['bottomMessage'] = '';
			this.sendRawNativeData(nativeData);
		});
	},

	closeWebViewV2: function () {
		const nativeData = {};
		nativeData['key'] = 146;
		this.sendRawNativeData(nativeData);
	},
	checkJuspaySdkInitializationStatus: function () {
		return new Promise((resolve, reject) => {
			const nativeData = {
				key: 103,
			};
			this.sendRawNativeData(nativeData);
			window.callbackHyperSdkInitStatus = (status) => {
				console.log('======callbackHyperSdkInitStatus======');
				console.log('Callback status-', status);
				// 1: inprogress, 0: uninitialized, 2: initialized
				if (Number(status) === 2) return resolve(true);

				this.initializeJuspayTransaction();
				return resolve(false);
			};
		});
	},

	initializeJuspayTransaction: function () {
		const nativeData = {
			key: 101,
			payload: {
				requestId: ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
					(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
				),
				service: 'in.juspay.hyperpay',
				payload: {
					action: 'initiate',
					merchantId: 'postpe',
					clientId: 'postpe',
					environment: 'production',
				},
			},
		};
		this.sendRawNativeData(nativeData);
		window.callbackHyperSdkInit = (status) => {
			// 1: inprogress, 0: uninitialized, 2: initialized
			console.log('===================callbackHyperSdkInit status callback======================', status);
		};
	},

	enableNotifications: function (dialogInfo) {
		const nativeData = {
			key: 122,
			dialogInfo: dialogInfo,
		};
		this.sendRawNativeData(nativeData);
	},
};

export default nativeFunctions;
